import { useState } from "react";
import {
  PaymentMethodAnimationConfiguration as AnimConfig,
  GlobalConfiguration,
} from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import Validation from "../../../utils/validation";
import AmountToWords from "../../_utils/AmountToWords";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import TextInputField from "../../_utils/CommonInputFields/TextInputField";
import CommonLayout from "../../_utils/CommonLayout";
import Loader from "../../Loader/Index";
import ICONS from "../../../assets/Icons";
import CommonToast from "../../_utils/CommonToast";

const TransferAmount = ({
  txnPayLoad,
  setTxnPayLoad,
  isNeft,
  setIsNeft,
  isRtgs,
  setIsRtgs,
  setIsImps,
  BenEnableNextButton,
  setShowRupeeSymbol,
  amountInWords,
  setAmountInWords,
  copyData,
  setCopyData,
  selectedValueName,
  setselectedValueName,
  NewAmount,
  type,
  currentAccountDetails,
  isStepValid,
  RequestAmountWords,
  txnLoading,
}) => {
  const RTGS_MIN_AMOUNT = 2_00_000;
  const [slideAnimation, setSlideAnimation] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (focused) {
      return length >= GlobalConfiguration.accountminLength
        ? "typing"
        : "typing";
    } else {
      if (length === GlobalConfiguration.lengthCheckZero) return "default";
      if (length < GlobalConfiguration.accountminLength) return "default";
      return "default";
    }
  };

  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");
    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
        // settleType: numericValue < RTGS_MIN_AMOUNT ? "neft" : "rtgs",
      }));
      setShowRupeeSymbol(false);
      setAmountInWords("");
      return;
    }

    if (trimmedValue[0] === "0") return;

    const enteredAmount = parseFloat(
      numericValue || GlobalConfiguration.lengthCheckZero,
    );
    const initialAmount = parseFloat(
      NewAmount || GlobalConfiguration.lengthCheckZero,
    );

    if (type === "PayReimburseTxn") {
      if (enteredAmount !== initialAmount) {
        setselectedValueName("customname");
      } else {
        setselectedValueName("username");
      }
    }

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const amountWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedAmountWords =
        amountNumber > 0 && amountNumber <= 1
          ? amountWords.replace("rupees", "rupee")
          : amountWords;

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountInWords: adjustedAmountWords,
      }));

      setAmountInWords(adjustedAmountWords);
      setShowRupeeSymbol(numericValue.trim() !== "");
      if (numericValue < RTGS_MIN_AMOUNT) {
        setIsRtgs(false);
        setIsNeft(true);
        setTxnPayLoad((p) => {
          return { ...p, settleType: "neft" };
        });
      } else {
        setIsRtgs(true);
        setIsNeft(false);
        setTxnPayLoad((p) => {
          return { ...p, settleType: "rtgs" };
        });
      }
    }
  };

  console.log(txnPayLoad);

  const handleAutofill = () => {
    setTxnPayLoad((prev) => ({
      ...prev,
      amount: NewAmount,
      amountInWords:
        NewAmount > GlobalConfiguration.lengthCheckZero &&
        NewAmount <= GlobalConfiguration.lengthCheckOne
          ? NewAmount.replace("rupees", "rupee")
          : NewAmount,
    }));
  };

  const handleRadioBtn = (event) => {
    setselectedValueName(event.target.value);
    if (event.target.value === "legalname") {
    } else if (event.target.value === "username") {
      handleAutofill();
    }
  };

  const handleDivBtn = (value) => {
    setselectedValueName(value);
    if (value === "legalname") {
    } else if (value === "username") {
      handleAutofill();
    }
  };

  const formattedAmount = (value) => {
    if (value === "" || value === null || value === undefined) {
      return "";
    }
    return Number(value).toFixed(GlobalConfiguration.lengthCheckTwo);
  };

  const isAmountExceeding =
    type === "PayReimburseTxn" &&
    selectedValueName === "customname" &&
    Number(txnPayLoad?.amount) > Number(NewAmount);

  return (
    <>
      {txnLoading ? (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-fixed-ui bg-PopUp-BackDrop opacity-dark-opacity">
            <div>
              <Loader type={"bulk_upload"} />
              <p className=" font-semibold text-font-lg text-text-primary">
                Validating the data
              </p>
            </div>
          </div>
        </>
      ) : (
        <div
          className="w-width-full h-height-full items-start px-padding-md Qlg:px-padding-base overflow-y-auto "
          style={{ scrollbarWidth: "none" }}
        >
          <CommonLayout>
            <div
              className="w-width-full max-h-auto rounded-border-radius-md"
              style={{ scrollbarWidth: "none" }}
            >
              {!isStepValid && (
                <>
                  <div className=" bg-emphasis flex mb-margin-md rounded-border-radius-md">
                    <div className=" flex p-padding-md  items-center justify-center">
                      <img
                        className=" w-icon-md h-icon-md "
                        src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                        alt="info"
                      />
                      <p className=" ml-margin-sm text-text-primary text-font-sm font-normal">
                        The transaction amount should not exceed the requested
                        amount.
                      </p>
                    </div>
                  </div>
                </>
              )}

              <Amount
                title={TEXT?.AMOUNT}
                onAmountExceedsRequested={(e) => {
                  CommonToast({
                    text: "Can not exceed requested amount.",
                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                    variant: "var(--error)",
                    buttonNeeded: false,
                  });
                }}
                amount={
                  type === "PayReimburseTxn" &&
                  Number(currentAccountDetails?.amount) ===
                    Number(txnPayLoad?.amount)
                    ? formattedAmount(currentAccountDetails?.amount)
                    : txnPayLoad?.amount
                }
                amountInWords={
                  type === "PayReimburseTxn" &&
                  currentAccountDetails?.amount === txnPayLoad?.amount
                    ? RequestAmountWords(currentAccountDetails?.amount)
                    : amountInWords
                }
                copyData={copyData}
                onAmountChange={(val) =>
                  handleAmountChange({ name: "amount", value: val })
                }
                onPasteApplied={() =>
                  setCopyData({ title: "", data_type: "", value: "" })
                }
                isPreview={false}
                handleRadioBtn={handleRadioBtn}
                NewAmount={NewAmount}
                selectedRadioValue={selectedValueName}
                handleDivBtn={(val) => handleDivBtn(val)}
                customAmountRequired={type === "PayReimburseTxn" ? true : false}
                isAmountExceeding={isAmountExceeding}
              />

              <div className="bg-primary-card mt-margin-md rounded-border-radius-md p-padding-md">
                <div className="mb-margin-md flex flex-col gap-gap-xs">
                  <h1 className="font-semibold text-text-primary text-font-md">
                    Comment <span className="font-normal">(Optional)</span>
                  </h1>
                  <div className="text-font-xs text-text-secondary">
                    Enter a comment to provide additional context for this
                    transaction.
                  </div>
                </div>
                <TextInputField
                  placeholder="Comment"
                  name="comment"
                  fontKind="big"
                  bgColor="var(--primary-card)"
                  fgColor="var(--text-primary)"
                  value={txnPayLoad?.comment}
                  isFullWidth={true}
                  adornment=""
                  variant={computeVariant(txnPayLoad?.comment, isFocused)}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  onInput={(e) => {
                    setTxnPayLoad((prev) => ({
                      ...prev,
                      comment: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
            <PaymentMethodSelector
              previewMode={false}
              autoSwitchDisabled={true}
              title={TEXT?.SELECT_PAYMENT_METHOD}
              slideAnimation={slideAnimation}
              methods={[
                {
                  key: "neft",
                  label: TEXT?.NEFT,
                  subText: TEXT?.NEFT_TRANSFER_NOTE,
                  active: isNeft,
                  notes: [
                    TEXT?.TRANSACTION_EXECUTION_NOTE,
                    TEXT?.TRANSACTION_LIMIT_NOTE,
                    TEXT?.TRANSACTION_CHARGES_NOTE,
                  ],
                  onClick: () => {
                    if (!isNeft) setSlideAnimation(true);
                    setTimeout(
                      () => setSlideAnimation(false),
                      AnimConfig.slideDuration,
                    );
                    setIsNeft(true);
                    setIsRtgs(false);
                    setTxnPayLoad({ ...txnPayLoad, settleType: "neft" });

                    // BenEnableNextButton(false);
                  },
                },
                {
                  key: "rtgs",
                  label: TEXT?.RTGS,
                  subText: TEXT?.INSTANT_TRANSFER_NOTE,
                  active: isRtgs,
                  notes: [
                    TEXT?.RTGS_TRANSACTION_EXECUTION_NOTE,
                    TEXT?.RTGS_TRANSACTION_LIMIT_NOTE,
                    TEXT?.TRANSACTION_CHARGES_NOTE,
                  ],
                  onClick: () => {
                    if (!isRtgs) setSlideAnimation(true);
                    setTimeout(
                      () => setSlideAnimation(false),
                      AnimConfig.slideDuration,
                    );
                    setIsNeft(false);
                    setIsImps(false);
                    setIsRtgs(true);
                    setTxnPayLoad({ ...txnPayLoad, settleType: "rtgs" });
                  },
                },
              ]}
            />
          </CommonLayout>

          {/* <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div> */}
        </div>
      )}
    </>
  );
};

export default TransferAmount;
